// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QXqRc","colBig":"styles_colBig__3ZRTp","colSmall":"styles_colSmall__2fD-B"};